const LoginHeading = () => {
  return (
    <div>
      <img
        className="mx-auto h-8 w-auto"
        src="medtax-logo.png"
        alt="medtax-logo"
      />
      <p className="text-center text-sm text-gray-400 px-14 mt-4">
        Your gateway to easy, worry-free taxation for Medical Doctors
      </p>
    </div>
  );
};

export default LoginHeading;
